module.exports = __webpack_public_path__ + "media/images/congrats-6d1a3daf.png";